module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_c('form', {
    staticClass: "form form--box border",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('h2', {
    staticClass: "form__title"
  }, [_vm._v("ลงทะเบียนผู้ใช้ใหม่")]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("อีเมล")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('email')
    },
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.email.empty),
      expression: "$v.$errors.email.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมล")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.$errors.email.empty && _vm.$v.$errors.email.invalid),
      expression: "!$v.$errors.email.empty && $v.$errors.email.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมลให้ถูกต้อง")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "password1"
    }
  }, [_vm._v("รหัสผ่าน")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('password1')
    },
    attrs: {
      "type": "password",
      "id": "password1"
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password1.empty),
      expression: "$v.$errors.password1.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่าน")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password1.minLength),
      expression: "$v.$errors.password1.minLength"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("รหัสผ่านต้องยาวไม่น้อยกว่า 6 ตัวอักษร")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password1.tooEasy),
      expression: "$v.$errors.password1.tooEasy"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาใช้รหัสผ่านที่เดายากกว่านี้")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "password2"
    }
  }, [_vm._v("ยืนยันรหัสผ่าน")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('password2')
    },
    attrs: {
      "type": "password",
      "id": "password2"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password2.empty),
      expression: "$v.$errors.password2.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่าน")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.$errors.password2.empty && _vm.$v.$errors.password2.unmatched),
      expression: "!$v.$errors.password2.empty && $v.$errors.password2.unmatched"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่านให้ตรงกัน")])]), _vm._v(" "), _c('h3', {
    staticClass: "form__title mt-30"
  }, [_vm._v("ข้อมูลส่วนตัว")]), _vm._v(" "), _c('div', {
    staticClass: "form__item mt-30"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("ชื่อจริง")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('firstName')
    },
    attrs: {
      "type": "text",
      "id": "firstName"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.firstName.empty),
      expression: "$v.$errors.firstName.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกชื่อของคุณ")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("นามสกุล")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('lastName')
    },
    attrs: {
      "type": "text",
      "id": "lastName"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.lastName.empty),
      expression: "$v.$errors.lastName.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกนามสกุล")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "telNo"
    }
  }, [_vm._v("เบอร์โทรศัพท์")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telNo),
      expression: "telNo"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('telNo')
    },
    attrs: {
      "type": "text",
      "id": "telNo",
      "placeholder": "0899999999"
    },
    domProps: {
      "value": (_vm.telNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telNo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.telNo.empty),
      expression: "$v.$errors.telNo.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุเบอร์โทรศัพท์ที่ติดต่อได้")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.$errors.telNo.empty && _vm.$v.$errors.telNo.invalid),
      expression: "!$v.$errors.telNo.empty && $v.$errors.telNo.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเบอร์โทรให้ถูกต้อง")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn--full",
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_vm._v("ลงทะเบียน")]), _vm._v(" "), _c('router-link', {
    staticClass: "font-sm",
    attrs: {
      "to": "/user/forgot"
    }
  }, [_vm._v("ลืมรหัสผ่าน?")]), _vm._v(" "), _c('router-link', {
    staticClass: "font-sm fl-right",
    attrs: {
      "to": "/user/login"
    }
  }, [_vm._v("เข้าสู่ระบบ")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637c4d53","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterPage.vue
// module id = 1177
// module chunks = 0